// extracted by mini-css-extract-plugin
export default {"UpcomingContainer":"upcoming_UpcomingContainer__MRba0","UpcomingCardContainer":"upcoming_UpcomingCardContainer__rvIpq","UpcomingTime":"upcoming_UpcomingTime__tyqGR"};